var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736240323433,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25543,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M833.792 191.232c-69.376 0-126.208 57.6-126.208 128 0 12.8 0 19.2 6.336 32L512 466.432l-201.92-115.2c6.336-12.8 6.336-19.2 6.336-32 0-70.4-56.832-128-126.208-128-69.44 0-126.208 57.6-126.208 128s56.768 128 126.208 128c37.824 0 69.376-19.2 94.656-44.8l195.584 115.2v224c-56.768 12.8-94.656 64-94.656 121.6 0 70.4 56.768 128 126.208 128s126.208-57.6 126.208-128c0-57.6-37.888-108.8-94.656-121.6v-224l201.92-108.8c18.944 19.2 50.496 38.4 88.32 38.4 69.44 0 126.208-57.6 126.208-128s-56.768-128-126.208-128z m-643.584 192c-37.888 0-63.104-25.6-63.104-64s25.216-64 63.104-64c37.824 0 63.104 25.6 63.104 64s-25.28 64-63.104 64z m384.896 480c0 38.4-31.552 64-63.104 64-37.888 0-63.104-25.6-63.104-64s25.216-64 63.104-64 63.104 25.6 63.104 64z m258.688-480c-37.824 0-63.104-25.6-63.104-64s25.28-64 63.104-64c37.888 0 63.104 25.6 63.104 64s-31.552 64-63.104 64z",
    fill: "#46766a",
    "p-id": 25544
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.928 511.232c-25.216 0-44.16-6.4-63.04-19.2v211.2c0 19.2 12.608 38.4 31.552 51.2l189.248 115.2v-6.4c0-19.2 6.336-38.4 12.608-57.6l-170.368-102.4v-192zM859.008 703.232l-170.304 96c6.272 19.2 12.608 38.4 12.608 57.6v6.4l189.248-115.2c18.944-12.8 31.616-32 31.616-51.2v-204.8c-18.944 6.4-44.16 12.8-63.168 19.2v192zM328.96 204.032L512 95.232l176.64 102.4c12.672-19.2 31.616-32 50.56-44.8L543.488 37.632c-18.944-6.4-44.16-6.4-63.104 0l-201.92 121.6c18.944 6.4 37.888 25.6 50.496 44.8z",
    fill: "#46766a",
    "p-id": 25545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/模型训练.197b102141b30bef5d8bf18583eed5f6.svg";
export { ForwardRef as ReactComponent };